import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Button from '@material-ui/core/Button';
import { useSelector, useDispatch } from 'react-redux';
import Header from '../../../../../../components/Stake/header';
import KsmIcon from '../../../../../../assets/images/tokens/ksm.svg';
import { KSM, CHAIN_NAMES } from '../../../../../../constants/blockchain-constants';
import KsmJsIcon from '../../../../../../assets/images/ksmJs.svg';
import ethIcon from '../../../../../../assets/images/currencies/eth-logo.svg';
import stylesConnect from '../../styles/connect/connect.module.scss';
import stylesParent from '../../styles/frame/frame.module.scss';
import Checkbox from '../../../../../../components/checkbox';
import { registerAddress } from '../../../../../../actions/delegator-reward-actions';

const ConnectConfirm = ({ setStatus }) => {
  const dispatch = useDispatch();
  const [checkbox, setCheckbox] = useState(false);
  const dark = useSelector((state) => state.basic.dark);
  const ethAddress = useSelector((state) => state.account.address);
  const kusamaAddress = useSelector((state) => state.kusamaAccount.address);
  const isNominating = useSelector((state) => state.delegator.kusama.isNominating);

  const mapAddress = async () => {
    try {
      setStatus(66);
      await dispatch(registerAddress(CHAIN_NAMES.KUSAMA));
      if (isNominating) {
        setStatus(2);
      } else {
        setStatus(1);
      }
    } catch (e) {
      setStatus(99);
    }
  };

  return (
    <>
      <Header icon={KsmIcon} title={`${KSM}-Nomination`} />
      <div className={stylesConnect.connectChain}>
        <div className={stylesConnect.chainItemWrapper}>
          <div className={stylesConnect.chainItem}>
            <div className={stylesConnect.chainItemIcon}>
              <img src={KsmJsIcon} alt='Kusama JS extention wallet icon' />
            </div>
            <div className={stylesConnect.chainItemValue}>{kusamaAddress}</div>
          </div>
        </div>
        <div className={stylesConnect.chainItemWrapper}>
          <div className={stylesConnect.chainItem}>
            <div className={stylesConnect.chainItemIcon}>
              <img src={ethIcon} alt='Kusama ETH' />
            </div>
            <div className={stylesConnect.chainItemValue}>{ethAddress}</div>
          </div>
        </div>
      </div>
      <div
        className={cn(
          stylesParent.cardFooterControls,
          stylesParent.withBackground,
          stylesParent.dotConfirm,
          {
            [stylesParent.dark]: dark,
          },
        )}
      >
        <Checkbox
          checked={checkbox}
          className={stylesConnect.checkbox}
          onChange={() => setCheckbox(!checkbox)}
        >
          <div className={stylesConnect.checkboxLabel}>
            You agree to bind this ERC-20 wallet address to this Kusama Wallet wallet address.
          </div>
        </Checkbox>
        <Button
          onClick={() => mapAddress()}
          variant='contained'
          color='secondary'
          className={stylesParent.cardFooterControlsButton}
          disabled={!checkbox}
        >
          Confirm
        </Button>
        <Button
          onClick={() => {
            setStatus(2);
          }}
          style={{ textTransform: 'none', marginTop: '0', width: '100%', borderRadius: '25px' }}
          variant='contained'
        >
          <span style={{ fontWeight: 800, color: 'gray' }}>Already connected</span>
        </Button>
      </div>
    </>
  );
};

ConnectConfirm.propTypes = {
  setStatus: PropTypes.func.isRequired,
};

export default ConnectConfirm;
